<template>
  <section class="room-upgrade-banner component">
    <div
      class="room-upgrade-banner__wrapper"
      :style="[
        {
          'background-image': `url(${previousRoomUpgradeImage}?wid=1280&hei=659&fmt=jpeg&op_usm=1,1,5,0&resMode=sharp2&fit=crop&qlt=75,0)`,
        },
      ]"
    >
      <span class="room-upgrade-banner__flag">{{ tc('booking.onlyMorePerNight', { price: getDisplayPrice({price: roomUpgradePriceDifference, withIsoCode: true, isoAfter: true})}) }}</span>
      <div class="room-upgrade-banner-content">
        <div class="room-upgrade-banner__eyebrow">
          {{ tc('booking.aBetterRoomAwaitsYou') }}
        </div>
        <div class="room-upgrade-banner__title">
          {{ tc('booking.upgradeYourStay') }}
        </div>
        <div class="room-upgrade-banner__ctas">
          <room-upgrade-modal>
            <template slot-scope="{ activate }">
              <button
                class="see-details-cta"
                @click.stop.prevent="activate"
                @keydown.space.stop.prevent="activate"
              >
                {{ tc('booking.seeDetails') }}
              </button>
            </template>
          </room-upgrade-modal>
          <button
            class="upgrade-cta"
            :class="{'loading': roomUpgradeLoading, 'upgrade-selected': roomUpgradeSelected}"
            @click.stop.prevent="handleRoomUpgradeClick"
            @keydown.space.stop.prevent="handleRoomUpgradeClick"
          >
            {{ roomUpgradeSelected ? tc('booking.removeUpgrade') : tc('booking.upgrade') }}
            <div
              class="sr-only"
              role="status"
            >
              {{ roomUpgradeLoading ? tc('accessibility.loadingButtonStatus') : '' }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'

  import RoomUpgradeModal from '../room-upgrade-modal/room-upgrade-modal.vue'

  export default {
    name: 'RoomUpgradeBanner',
    components: {
      RoomUpgradeModal
    },
    computed: {
      ...mapState('cart', ['cart', 'roomUpgradeLoading', 'roomUpgradeSelected', 'previousRoomUpgradeImage', 'roomUpgradePriceDifference', 'roomUpgradeAvailable']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', ['getBookingTrackingV2', 'getQuery']),
      ...mapGetters('currency', ['getDisplayPrice']),
    },
    methods: {
      ...mapActions('cart', ['applyRoomUpgrade', 'removeRoomUpgrade']),
      async handleRoomUpgradeClick() {
        if (this.roomUpgradeSelected) {
          this.removeRoomUpgrade().then(() => {
            this.$track(this.getBookingTrackingV2(this.getQuery, { event: 'upgradeRemoved', upgradeName: `${this.cart.lines[0].sitecoreContent.room.title} - ${this.cart.lines[0].sitecoreContent.bed.title}` }))
          })
        } else {
          this.applyRoomUpgrade().then(() => {
            this.$track(this.getBookingTrackingV2(this.getQuery, { event: 'step8', upgradeName: `${this.roomUpgradeAvailable.title} - ${this.roomUpgradeAvailable.bedType[0].title}` }))
          })
        }
      }
    }
  }
</script>
